import React, { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Divider,
  IconButton,
  Stack
} from '@mui/material';

import XBigIcon from '@/assets/icons/x-big.svg?react';
import typography from '@/theme/typography';

import SaveChangesIllustration from './assets/save-changes.svg?react';
interface ConfirmationModalProps {
  open: boolean;
  onConfirm?: () => void;
  onDiscard?: () => void;
  onClose?: () => void;
  title: string | ReactNode;
  confirmButtonLabel?: string;
  confirmButtonStartIcon?: ReactNode;
  discardButtonLabel?: string;
  loadingLabel?: string;
  illustration?: ReactNode;
  isLoading?: boolean;
  isBlockingModal?: boolean;
}

const ConfirmationModal: FC<ConfirmationModalProps> = ({
  open,
  onConfirm,
  onDiscard,
  onClose,
  title,
  confirmButtonLabel,
  confirmButtonStartIcon,
  discardButtonLabel,
  loadingLabel,
  isLoading,
  isBlockingModal = false
}) => {
  const { t } = useTranslation(['settings', 'common']);

  return (
    <Dialog open={open} onClose={isLoading || isBlockingModal ? undefined : onClose}>
      <Box sx={{ position: 'absolute', top: 0, right: 0, p: 1 }}>
        <IconButton onClick={onClose}>
          <XBigIcon />
        </IconButton>
      </Box>
      <Stack alignItems="center" pt={2}>
        <SaveChangesIllustration />
      </Stack>
      <DialogContent sx={{ textAlign: 'center', p: 2 }}>
        <DialogContentText
          sx={{ ...typography.body2, color: 'text.primary', whiteSpace: 'pre-line', maxWidth: '100%' }}
        >
          {typeof title === 'string' ? t(title) : title}
        </DialogContentText>
      </DialogContent>
      <Divider orientation="horizontal" sx={{ borderColor: 'grey.400' }} />
      <DialogActions sx={{ justifyContent: 'space-between', flexWrap: 'wrap', width: '100%', p: 2 }}>
        <Button onClick={onDiscard} color="primary" disabled={isLoading}>
          {discardButtonLabel || t('settings.cancelButton')}
        </Button>
        <Button
          onClick={onConfirm}
          color="primary"
          autoFocus
          variant="contained"
          disabled={isLoading}
          startIcon={!isLoading ? confirmButtonStartIcon : undefined}
        >
          {isLoading ? loadingLabel || t('saving', { ns: 'common' }) : confirmButtonLabel || t('settings.saveButton')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModal;
